// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"348":"7b771b33","669":"48953c11","793":"3f1af63b","938":"b3dcf610","975":"c6724e69"}[chunkId] + ".chunk.js";
};